"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TocOptionsPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const slate_react_1 = require("slate-react");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const EditorContextPopup_1 = require("../../../chrome/EditorContextPopup");
const TocOptions_1 = require("./TocOptions");
const state_1 = require("./state");
const use_t_1 = require("use-t");
const TocOptionsPopupBody = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, state_1.useTocOptionsState)();
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: t('Table of contents'), subtitle: t('Configure how the document outline is rendered.'), minWidth: 320, onCancel: state.cancel, onApply: state.apply },
        React.createElement(TocOptions_1.TocOptions, null)));
};
const TocOptionsPopup = ({ element, closePopup }) => {
    const editor = (0, slate_react_1.useSlateStatic)();
    const popup = (0, context_1.usePopup)();
    const onClose = React.useCallback(() => {
        if (closePopup)
            closePopup();
        else
            popup?.close();
    }, [closePopup, popup]);
    return (React.createElement(state_1.TocOptionsStateProvider, { editor: editor, element: element, closePopup: onClose },
        React.createElement(TocOptionsPopupBody, null)));
};
exports.TocOptionsPopup = TocOptionsPopup;
